export default __webpack_public_path__ + "static/media/Logo.31796f8c.png";